<template>
  <div id="employees">
   <!-- Search Codde -->
    <v-dialog v-model="showCodeSearch" persistent max-width="400">
      <v-card>
         <form novalidate class="md-layout" @submit.prevent="searchMember">
        <v-card-title class="headline">{{'members._enter_access_code_'|translate}}</v-card-title>
        <v-progress-linear :indeterminate="false"></v-progress-linear>
        <v-card-text>
           <v-text-field
            v-model="accessCode"
            :rules="[rules.required, rules.counter]"
            :label="$t('members._accesscode_')"
            counter
            maxlength="5"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="showCodeSearch=false">{{'general._finish_'|translate}}</v-btn>
          <v-btn color="green darken-1" type="submit" flat>{{'general._search_'|translate}}</v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <!-- Search Name -->
    <v-dialog v-model="showNameSearch" persistent max-width="400">
      <v-card>
         <form novalidate class="md-layout" @submit.prevent="searchName">
        <v-card-title class="headline">{{'members._lastname_'|translate}}</v-card-title>
        <v-progress-linear :indeterminate="false"></v-progress-linear>
        <v-card-text>
           <v-text-field
            v-model="lastName"
            :rules="[rules.required]"
            :label="$t('members._lastname_')"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="showNameSearch=false">{{'general._finish_'|translate}}</v-btn>
          <v-btn color="green darken-1" type="submit" flat>{{'general._search_'|translate}}</v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex sm12>
           <v-toolbar color="indigo" dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{'members._search_members_'|translate}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="showNameSearch = true" icon>
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-btn @click="showCodeSearch = true" icon>
          <v-icon>search</v-icon>
        </v-btn>
      </v-toolbar>
          </v-flex>          
          <v-flex lg3 sm12 v-for="(item,index) in cards" :key=" 'bottom-nav' + index">
            <name-card-search
              bottom-nav
              v-bind="item"
            >
            </name-card-search>
          </v-flex>    
          <!-- <v-flex sm12>
            <h4>Contact Card</h4>  
          </v-flex>      
          <v-flex lg4 sm12>
            <profile-card></profile-card>
          </v-flex> -->
        </v-layout>
      </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import NameCardSearch from '@/components/widgets/card/NameCardSearch';
// import ProfileCard from '@/components/widgets/card/ProfileCard';
export default {
  components: {
    NameCardSearch,
    // ProfileCard
  },
  data () {
    return {
     showNameSearch: false,
     showCodeSearch: false,
     lastName: '',
     accessCode: '',
     members: [],
     cards: [],
     rules: {
        required: value => !!value || this.$t('members._access_code_validation_'),
        counter: value => value.length <= 5 || this.$t('members._five_char_validation_')
      },
    };
  },
  created () {
    this.members = this.$store.getters.valideUsers;
  },
 computed: {
    //  members () {
    //   let members = this.$store.getters.valideUsers;
    //   this.loading = false;
    //   return members;
    // }
  },
  methods: {
   searchMember () {
     this.accessCode = this.accessCode.toLowerCase()
      db
      .collection('Census')
      .where('lowerAccessCode', "==", this.accessCode)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
                 const data = {
            id: doc.id,
            avatar: {
              src: doc.data().imageUrl,
              size: 72
            },
            firstName: doc.data().firstName,
            lastName: doc.data().lastName
            }
            this.cards.push(data)
         })
         if (!this.cards.length) {
            alert(this.$t('members._no_acess_code_'));
           } else {
             this.$store.commit('currentMemberId', this.member_id)
             this.accessCode = ''
             this.showCodeSearch = false
        }
          })   
    },
  searchName () {
   this.cards = []
   this.lastName = this.lastName.toLowerCase()
           db
      .collection('Census')
      .where('lowerLastName', "==", this.lastName)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            avatar: {
              src: doc.data().imageUrl,
              size: 72
            },
            firstName: doc.data().firstName,
            lastName: doc.data().lastName
            }
            this.cards.push(data)
         })
           if (!this.cards.length) {
            alert(this.$t('members._no_lastname_'));
           } else {
            // if (this.cards.length > 1) { alert(`${this.cards.length} membres trouvés`) }
            // else { alert(`${this.cards.length} membre trouvé`) }
            this.showNameSearch = false
            this.lastName = ''
           }
          })
      }

    }
 }
</script>


// WEBPACK FOOTER //
// src/pages/widgets/Search.vue